import { login as cLogin, getUserInfo as cGetUserInfo } from "@/api/user";
import { login as bLogin, getUserInfo as bGetUserInfo } from "@/api/business";
import checkPermission from "@/utils/permission";

const state = {
  token: sessionStorage.getItem('token'),
  userInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {},
  roles: sessionStorage.getItem('roles') ? JSON.parse(sessionStorage.getItem('roles')) : [],
}

const mutations = {
  SET_TOKEN(state, token) {
    sessionStorage.setItem('token', token)
    state.token = token
  },
  SET_USERINFO(state, userInfo) {
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    state.userInfo = userInfo
  },
  SET_ROLES(state, roles) {
    sessionStorage.setItem('roles', JSON.stringify(roles))
    state.roles = roles
  },
  REMOVE_USERINFO(state) {
    state.userInfo = {}
    sessionStorage.removeItem('userInfo')
  },
  REMOVE_ROLES(state) {
    state.roles = [],
    sessionStorage.removeItem('roles')
  },
  REMOVE_TOKEN(state) {
    state.token = undefined
    sessionStorage.removeItem('token')
  }
}

const actions = {
  async login({ commit }, loginInfo) {
    const { staffType } = loginInfo
    let loginFun = cLogin
    if (staffType === 'BUSINESS') loginFun = bLogin
    const token = await loginFun(loginInfo).then(res => res.data.d)
    commit('SET_TOKEN', token)
    return token
  },
  async getUserInfo({ commit }, type) {
    let getFun = cGetUserInfo
    const platform = sessionStorage.getItem('platform')
    if (platform ==='BUSINESS') getFun = bGetUserInfo
    const userInfo = await getFun().then(res => res.data.d)
    const { type: userType, secondaryType, educationStage } = userInfo
    const roles = [userType, secondaryType, educationStage].filter(item => item)
    userInfo.roles = roles
    commit('SET_ROLES', roles)
    commit('SET_USERINFO', userInfo)
    return userInfo
  },
  logout({ commit }) {
    commit('REMOVE_USERINFO')
    commit('REMOVE_ROLES')
    commit('REMOVE_TOKEN')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js